
import React from "react";
import { X } from "lucide-react";

interface BlogCategoriesFilterProps {
  categories: string[];
  selectedCategory: string | null;
  onSelectCategory: (category: string | null) => void;
}

const BlogCategoriesFilter: React.FC<BlogCategoriesFilterProps> = ({
  categories,
  selectedCategory,
  onSelectCategory,
}) => {
  return (
    <div>
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => onSelectCategory(null)}
          className={`px-3 py-1.5 rounded-full text-sm font-medium ${
            selectedCategory === null
              ? "bg-[#FA8C00] text-white shadow-md"
              : "bg-gray-100 hover:bg-gray-200 text-secondary"
          } transition-colors`}
        >
          All Posts
        </button>
        
        {categories.map(category => (
          <button
            key={category}
            onClick={() => onSelectCategory(category)}
            className={`px-3 py-1.5 rounded-full text-sm font-medium ${
              selectedCategory === category
                ? "bg-[#FA8C00] text-white shadow-md"
                : "bg-gray-100 hover:bg-gray-200 text-secondary"
            } transition-colors`}
          >
            {category}
          </button>
        ))}
      </div>
      
      {selectedCategory && (
        <div className="mt-3 flex items-center">
          <span className="text-sm text-secondary/80 mr-2">
            Filtering by: <span className="font-medium">{selectedCategory}</span>
          </span>
          <button
            onClick={() => onSelectCategory(null)}
            className="text-[#F75C57] hover:text-[#F75C57]/80"
            aria-label="Clear filter"
          >
            <X size={16} />
          </button>
        </div>
      )}
    </div>
  );
};

export default BlogCategoriesFilter;
